import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';

export const RoundFilledIconWrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    border-radius: ${getPurpurBorder('radiusFull')};
    color: ${getPurpurColor('textDefault')};
    background: ${getPurpurColor('gray50')};
    height: 4rem;
    width: 4rem;
`;
